import { useEffect } from "react"

/**
 * A soft ripple where the mouse clicks (the app cursor's click feedback). Mouse only — touch and
 * pen already have their own feedback — and off for people who prefer reduced motion.
 */
export function ClickRipple() {
  useEffect(() => {
    const reduce = window.matchMedia?.("(prefers-reduced-motion: reduce)")
    const onDown = (e: PointerEvent) => {
      if (e.pointerType !== "mouse" || e.button !== 0 || reduce?.matches) return
      const r = document.createElement("span")
      r.className = "click-ripple"
      r.setAttribute("aria-hidden", "true")
      r.style.left = `${e.clientX}px`
      r.style.top = `${e.clientY}px`
      document.body.appendChild(r)
      const remove = () => r.remove()
      r.addEventListener("animationend", remove, { once: true })
      window.setTimeout(remove, 800)
    }
    window.addEventListener("pointerdown", onDown, { capture: true, passive: true })
    return () => window.removeEventListener("pointerdown", onDown, { capture: true })
  }, [])
  return null
}
